import { useLocation } from "react-router-dom";

export default function useProductId() {
  const searchParams = new URL(window.location.href);
  let productId = searchParams.pathname.split('/')[1];
  return productId
};